import { mergeFieldMaps } from '@/common/utils/jsonUniData'

function readExchangeFieldMap(documentData: Record<string, unknown>): Record<string, unknown> | null {
  const jsChanged = (documentData.jsResult as { changed_data?: unknown } | undefined)?.changed_data
  const chain = documentData.currentChainData
  for (const source of [jsChanged, chain]) {
    if (!source || typeof source !== 'object') continue
    const fieldsRoot = (source as { fields?: unknown }).fields
    if (!fieldsRoot || typeof fieldsRoot !== 'object') continue
    const inner = (fieldsRoot as { fields?: unknown }).fields
    if (inner && typeof inner === 'object' && !Array.isArray(inner)) {
      return inner as Record<string, unknown>
    }
  }
  return null
}

export function seedPlatformOpenPageUniData(documentData: Record<string, unknown>): void {
  const incoming = readExchangeFieldMap(documentData)
  if (!incoming || Object.keys(incoming).length === 0) {
    return
  }

  if (!documentData.uniData || typeof documentData.uniData !== 'object') {
    documentData.uniData = {}
  }
  const uniData = documentData.uniData as Record<string, unknown>
  if (!uniData.fields || typeof uniData.fields !== 'object') {
    uniData.fields = {}
  }
  const fieldsRoot = uniData.fields as Record<string, unknown>
  if (!fieldsRoot.fields || typeof fieldsRoot.fields !== 'object') {
    fieldsRoot.fields = {}
  }
  const existing = fieldsRoot.fields as Record<string, unknown>
  fieldsRoot.fields = mergeFieldMaps(existing, incoming)
}
